<template>
  <a-list-item v-on:click.stop="onClick"
               v-bind:class="{'is-active': isActive}"
               class="selectable-result"
               slot="renderItem"
               :data-dusk="'selectable-result-' + customer.id"
  >
    <a-list-item-meta>
      <span slot="title">
        {{ customer.full_name }}
        <span v-if="hasAddress">
          {{ propertyAddress }}<br>
          {{ propertyPostal }}
        </span>
        <span v-else>-</span>
      </span>
      <a-avatar
          slot="avatar"
          class="selectable-result-avatar"
          :src="avatarUri"
      />
    </a-list-item-meta>
  </a-list-item>
</template>

<script>
export default {
  name: "SelectableResultComponent",
  props: {
    customer: {
      type: Object,
      required: true
    },
    isActive: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data() {
    return {};
  },
  computed: {
    avatarUri() {
      return '/customer/' + this.customer.id + '/avatar';
    },
    hasAddress() {
      return (this.customer.current_visit_customer_property !== null
          && typeof this.customer.current_visit_customer_property !== 'undefined'
          && this.customer.current_visit_customer_property.data.property !== null
          && typeof this.customer.current_visit_customer_property.data.property !== 'undefined'
      );
    },
    currentVisitProperty() {
      if (!this.hasAddress) return null;

      const property = this.customer?.current_visit_customer_property?.data?.property?.data ?? null;

      if (property !== null && typeof property !== 'undefined' && Object.keys(property).length !== 0) {
        return {
          street: property.street,
          number: property.number,
          number_letter: property.number_letter ? property.number_letter : '',
          number_addition: property.number_addition ? property.number_addition : '',
          postal_code: property.postal_code.toUpperCase(),
          city: property.city ? property.city.charAt(0).toUpperCase() + property.city.slice(1) : ''
        };
      }

      return null;
    },
    propertyAddress() {
      const property = this.currentVisitProperty;

      return property?.street + ' ' + property.number + property.number_letter + '-' + property.number_addition;
    },
    propertyPostal() {
      const property = this.currentVisitProperty;

      return property?.postal_code + ' ' + property.city;
    }
  },
  methods: {
    onClick() {
      this.$emit('customer-selected', this.customer);
    }
  }
}
</script>
<style scoped>
.selectable-result {
  cursor: pointer;
}

.selectable-result:hover {
  background: #eaf1fd;
}

.selectable-result .selectable-result-avatar {
  height: 25px;
  width: 25px;
}

.selectable-result.is-active {
  background-color: #1890ff;
}

.selectable-result.is-active .ant-list-item-meta-title span {
  color: white;
}

.selectable-result.is-active .selectable-result-avatar {
  border: solid 2px white;
}
</style>